/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * FacilityFlow API
 * Eine professionelle Web API für Facility Management mit Versionierung, Logging und Observability.
 * OpenAPI spec version: 1.0
 */

export type FacilityFlowCoreModulesPlanningEntitiesTimeClockDayStatus = typeof FacilityFlowCoreModulesPlanningEntitiesTimeClockDayStatus[keyof typeof FacilityFlowCoreModulesPlanningEntitiesTimeClockDayStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FacilityFlowCoreModulesPlanningEntitiesTimeClockDayStatus = {
  NUMBER_1: 1,
  NUMBER_2: 2,
} as const;
